import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = { class: "max-w-5xl mx-auto px-6 py-10" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "text-[#9CA3AF] leading-relaxed text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "text-emerald-400"
}
const _hoisted_6 = {
  key: 1,
  class: "skeleton-shine animate-shimmer text-transparent"
}
const _hoisted_7 = {
  key: 2,
  class: "text-emerald-400"
}
const _hoisted_8 = {
  key: 3,
  class: "skeleton-shine animate-shimmer text-transparent"
}
const _hoisted_9 = { class: "bg-gradient-to-br from-white/5 to-white/10 rounded-xl p-6 mb-10 backdrop-blur-sm" }
const _hoisted_10 = { class: "flex items-center gap-2 bg-[#1A1A1A]/80 p-3 rounded-lg mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "text-xl font-bold tracking-wider text-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "skeleton-shine animate-shimmer w-[340px] h-8"
}

import { ref } from 'vue'
import { Copy, Check, Award, Users, Search, Gift, DollarSign } from 'lucide-vue-next'
import { usePaymentGatewayIntegration } from '@/composables/usePaymentGatewayIntegration'
import { PaymentGatewayIntegration } from '@/interfaces/payment-gateway-integrations/PaymentGatewayIntegration'

// Animação de cópia do código

export default /*@__PURE__*/_defineComponent({
  __name: 'ManageAffiliationView',
  setup(__props) {

const { paymentGatewayIntegration } = usePaymentGatewayIntegration()
const codeCopied = ref(false)
const copyCode = () => {
  navigator.clipboard.writeText(paymentGatewayIntegration.value?.organizationUUID ?? '')
  codeCopied.value = true
  
  setTimeout(() => {
    codeCopied.value = false
  }, 2000)
}

// Dados de exemplo para a tabela
// const indicacoes = [
//   {
//     nome: 'João Silva',
//     email: 'joao.silva@email.com',
//     data: '12/03/2025',
//     status: 'Convertido',
//     plano: 'Plano Premium',
//     recompensa: 'R$ 20,00'
//   },
//   {
//     nome: 'Maria Oliveira',
//     email: 'maria.oliveira@email.com',
//     data: '10/03/2025',
//     status: 'Convertido',
//     plano: 'Plano Premium',
//     recompensa: 'R$ 20,00'
//   },
//   {
//     nome: 'Carlos Mendes',
//     email: 'carlos.mendes@email.com',
//     data: '08/03/2025',
//     status: 'Pendente',
//     plano: '',
//     recompensa: ''
//   },
//   {
//     nome: 'Ana Souza',
//     email: 'ana.souza@email.com',
//     data: '05/03/2025',
//     status: 'Convertido',
//     plano: 'Plano upsell',
//     recompensa: 'R$ 10,00'
//   },
//   {
//     nome: 'Pedro Costa',
//     email: 'pedro.costa@email.com',
//     data: '01/03/2025',
//     status: 'Expirado',
//     plano: '',
//     recompensa: ''
//   }
// ]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-3xl font-bold mb-3" }, "Indique e Ganhe!", -1)),
        _createElementVNode("p", _hoisted_4, [
          _cache[0] || (_cache[0] = _createTextVNode(" Indique alguém para o BOT EXPRESS e receba uma comissão sobre cada venda realizada por essa pessoa. O melhor de tudo é que sua comissão vem das taxas da plataforma, sem impactar os ganhos de quem você indicar. A cada transação concluída pelo indicado, você recebe ")),
          (_unref(paymentGatewayIntegration))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(paymentGatewayIntegration)?.referralCommissionPercentage) + "%", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "0%")),
          _cache[1] || (_cache[1] = _createTextVNode(" + ")),
          (_unref(paymentGatewayIntegration))
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(paymentGatewayIntegration)?.referralCommissionAmount?.toLocaleString('pt-BR', { currency: 'brl', style: 'currency' })), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "R$ 0,00")),
          _cache[2] || (_cache[2] = _createTextVNode(" do valor da venda. Aproveite essa oportunidade para aumentar sua renda. "))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Seu código de indicação", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-[#9CA3AF] text-sm mb-4" }, " Compartilhe este código com seus amigos e ganhe recompensas quando eles se cadastrarem. ", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(Gift), { class: "h-5 w-5 text-emerald-400 mr-1" }),
          (_unref(paymentGatewayIntegration))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(paymentGatewayIntegration).organizationUUID), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_12)),
          _createElementVNode("button", {
            onClick: copyCode,
            class: "text-[#9CA3AF] hover:text-white p-1.5 rounded-md hover:bg-white/10 transition-colors"
          }, [
            (codeCopied.value)
              ? (_openBlock(), _createBlock(_unref(Check), {
                  key: 0,
                  class: "h-5 min-w-5 text-emerald-500"
                }))
              : (_openBlock(), _createBlock(_unref(Copy), {
                  key: 1,
                  class: "h-5 min-w-5"
                }))
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-[#9CA3AF] text-xs" }, "Todos os convites são vitalícios.", -1))
      ])
    ])
  ]))
}
}

})